import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-memberList',
  templateUrl: './memberlist.component.html'
})
export class MemberListComponent implements OnInit {
  @Input('workgroupMembers') workgroupMembers: any;
  @Input('usingClearancelevel') usingClearancelevel!: boolean;
  @Output('triggerAction') triggerAction = new EventEmitter();
  filterWorkgroupMembers = { count: -1 };
  itemsPerPage: number = 10;
  currentPage: number = 1;
  pageSize!: number;


  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  TriggerAction(event:Event){
    this.triggerAction.emit(event);
  }

  onPageChanged(pageNum: any): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }

  changePagesize(num:number): void {
    this.itemsPerPage = num;
  }

}
